import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: Fields = {
  resolved: {},
};

export interface Fields {
  resolved: Record<string, string>;
}

const reducer = createSlice({
  name: 'place-id-resolver',
  initialState,
  reducers: {
    saveResult: (state, action: PayloadAction<{ placeId: string; formattedAddress: string }>) => {
      state.resolved[action.payload.placeId] = action.payload.formattedAddress;
    },
  },
});

export const { saveResult } = reducer.actions;

export default reducer.reducer;
